import React from 'react';
import classnames from 'classnames';
import { fromPairs, map, get, isEqual, isEmpty, size } from 'lodash';

// local Dependencies
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { dateTimeSelection as DateTimeSelection } from 'modules/dateTimeSelection';
 *
 * // render
 * <DateTimeSelection propName='propValue'/>
 */
export const dateTimeSelection = ( props ) => {

    const className = classnames( 'ui-date-time-selection', props.className );
    const hasError = ! isEmpty( props.errorMessage );

    return (
        <div className={ className } onClick={ ( event ) => event.stopPropagation() }>
            <Form
                fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                values={ props.values } // default values
                isValid={ false }
                mode='form'
                key={ size( props.value ) }
                onChangeCallBack={ props.onChangeCallBack }
                updatFieldsOnChange={ true }
                onSubmit={ ( { values, isValid } ) => {
                    if( isValid ) {
                        
                        props.onFormSubmit( {
                            daysOpen: values.daysOpen,
                            openTime: values.openTime,
                            closeTime: values.closeTime
                        } );
                    }
                } }
            >
                { ( { fields, values, isValid, errors, onChange, onSumbit } = {} ) => {

                    return (
                        <form

                            // onSubmit={ onSumbit }
                            className='ui-date-time-selection__form'
                        >
                            { /* fields */ }
                            { map( fields, ( field ) => {

                                if( get( field, 'config.hide' ) ) {
                                    return null;
                                }

                                const fieldClassName = classnames( 'ui-date-time-selection__form__field', `ui-date-time-selection__form__${field.name}` );

                                return (
                                    <field.view
                                        className={ fieldClassName }
                                        key={ field.name }
                                        name={ field.name }
                                        required={ field.required }
                                        placeholder={ field.placeholder }
                                        label={ field.title }
                                        onChange={ onChange }
                                        value={ values[ field.name ] }
                                        error={ errors[ field.name ] }
                                        
                                        // options={ get( props.options, field.options ) }
                                        config={ field.config }
                                        subFields={ props.subFields }
                                        mask={ field.mask }
                                    />
                                );
                            } ) }
                            {/* button actions */}
                            <div className='ui-date-time-selection__form__actions'>
                                { map( props.actions, action => {
                                    return (
                                        <Button
                                            key={ action.name }
                                            id= { action.name }
                                            type= {  'button' }
                                            disabled={ 'cancel' !== action.name ? !isValid : false }
                                            { ...action }
                                            outline={ false }
                                            size='large'
                                            className='ui-date-time-selection__form__actions__action'
                                            onClick = { isEqual( 'cancel', action.name ) ?  () => {

                                                // popover.close();
                                                props.onCancelClick();
                                            } : () => onSumbit() }
                                        />
                                    );
                                } ) }
                            </div>
                        </form>
                    );
                } }
            </Form>

            {
                hasError && ! isEqual( props.mode, 'readonly' ) ? (
                    <div className='ui-date-time-selection__error'>
                        <div className='ui-date-time-selection__error__message'>
                            { getLabel( props.errorMessage ) }
                        </div>
                    </div>
                ) : null
            }

            { ! isEmpty( props.value ) && (
                <div className='ui-date-time-selection__selection'>

                    <div className='ui-date-time-selection__selection__header'>

                        { map( props.fields, field => {
                            return (
                                <div key={ field.name }  className='ui-date-time-selection__selection__header__section'>{ getLabel( field.title ) }</div>
                            );
                        } ) }

                    </div>

                    { map( props.value, ( val, index ) => {
                        return (
                            <div key={ index } className='ui-date-time-selection__selection__list'>
                                <div className='ui-date-time-selection__selection__list__section'>{ val.daysOpen }</div>
                                <div className='ui-date-time-selection__selection__list__section'>{ val.openTime }</div>
                                <div className='ui-date-time-selection__selection__list__section'>{ val.closeTime }</div>
                                <div className='ui-date-time-selection__selection__list__action' onClick={ () => props.clearSelection( index ) }>
                                    <Icon id={ 'delete' } />
                                </div>
                            </div>
                        );
                    } ) }
                </div>
            ) }

        </div>
    );
};

// set display name
dateTimeSelection.displayName = 'dateTimeSelection';

// set default props
dateTimeSelection.defaultProps = {};

// prop types
dateTimeSelection.propTypes = {};
